import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import CssBaseline from "@mui/material/CssBaseline";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Fab from "@mui/material/Fab";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Fade from "@mui/material/Fade";
import IconButton from "@mui/material/IconButton";
import HomeIcon from "@mui/icons-material/Home";
import CheckIcon from "@mui/icons-material/Check";
import { Segment, Header, Grid, Divider } from "semantic-ui-react";
import "../../../scss/index.scss";
import { estiloSegmento } from "../../../estilos/segmentos";
import { estiloColores } from "../../../estilos/colores";
import { apiUsuario } from "../../../api/usuario";
import Swal from "sweetalert2";
import {
  cambios_registrados_correctamente,
  error_al_guardar_cambios,
  email,
} from "../../../utils/traductor";
import { apiIdioma } from "../../../api/idioma";
// import { apiLocalidad } from "../../../api/localidad";
import {
  nombre,
  apellido,
  idioma,
  // localidad,
  contacto,
  telefono,
  numero_de_identificacion,
  general,
  otros,
  contactos_de_emergencia,
  editar_perfil,
  identificacion,
} from "../../../utils/traductor";
import { ENTORNO } from "../../../utils/constantes";
import {
  getrole,
  setemail,
  setNombre,
  setApellido,
  setIdioma,
  setTelefono,
  // setLocalidad,
  setContactosEmergencia,
  setavatar,
  setTitulo,
  getIdentificacion,
  setIdentificacion,
  getid,
  setPoolingActivado,
} from "../../../utils/variablesLocales";
import {
  initialValues,
  validationSchema,
} from "../../../componentes/Pasajero_EditarPerfil";
import "../../../scss/index.scss";
import { TextField } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import NativeSelect from "@mui/material/NativeSelect";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import animacion from "../../../imagenes/AnimacionesVarias/LoadingMap.json";
import { Player } from "@lottiefiles/react-lottie-player";

function ScrollTop(props) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      "#back-to-top-anchor"
    );

    if (anchor) {
      anchor.scrollIntoView({
        block: "center",
      });
    }
  };

  return (
    <Fade in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{ position: "fixed", bottom: 16, right: 16 }}
      >
        {children}
      </Box>
    </Fade>
  );
}

ScrollTop.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

const apiidioma = new apiIdioma();
// const apilocalidad = new apiLocalidad();
const apiusuario = new apiUsuario();

export function EditarPerfil(props) {
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  const Titulo = editar_perfil;
  setTitulo(Titulo);

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        //guardar cambios
        setemail(formik.values.email);
        setNombre(formik.values.nombre);
        setApellido(formik.values.apellido);
        setTelefono(formik.values.telefono);
        setIdentificacion(formik.values.identificacion);
        setIdioma(formik.values.idioma);
        //setLocalidad(formik.values.localidad);
        //setContactosEmergencia(formik.values.contactosemergencia);
        setavatar(formik.values.avatar.replace("uploads/", ""));

        const respuesta = await apiusuario.actualizarAvatar(
          formik.values.nombre,
          formik.values.apellido,
          formik.values.idioma,
          formik.values.email,
          formik.values.telefono,
          formik.values.identificacion,
          formik.values.fileAvatar
        );

        if (respuesta.status === 200) {
          Swal.fire({
            title: "",
            text: cambios_registrados_correctamente,
            icon: "success",
            confirmButtonText: "Ok",
            confirmButtonColor: estiloColores.Azul,
          }).then(function () {
            //muestro back-drop
            setOpen(true);

            window.location.reload(true);
          });
        } else {
          Swal.fire({
            title: "Error!",
            text: error_al_guardar_cambios,
            icon: "error",
            confirmButtonText: "Ok",
            confirmButtonColor: estiloColores.Gris,
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
  });

  ////////////////////////////////

  const [idiomas, setIdioma1] =
    useState(
      null
    ); /*esta variable idiomas, maneja el estado del item seleccionado en el combo idioma*/

  // const [localidades, setLocalidad1] =
  //   useState(
  //     null
  //   ); /*esta variable localidades, maneja el estado del item seleccionado en el combo localidad*/

  const [yaCargo, setyaCargo] = useState(false);

  const navigate = useNavigate();

  const [SistemaOperativo, setSistemaOperativo] = useState("");

  useEffect(() => {
    (async () => {
      try {
        //controlando la seguridad para que solo acceda a esta pantalla el perfil que corresponda
        if (getrole() !== "Pasajero") {
          navigate(ENTORNO.URL_APLICACION + "/CerrarSesion");
        }
        ///////////////////////////////////////////////////////

        ////////////////////////////////////
        //detectar sistema operativo
        const userAgent = navigator.userAgent.toLowerCase();
        setSistemaOperativo(userAgent);
        ////////////////////////////////////

        if (!yaCargo) {
          setyaCargo(true);

          //obtengo la lista de idiomas para luego cargar el combo
          const respuesta = await apiidioma.obtener();
          setIdioma1(respuesta);

          // //obtengo la lista de localidades para luego cargar el combo
          // const respuesta1 = await apilocalidad.obtener();
          // setLocalidad1(respuesta1);
        }

        document.body.style.zoom = "100%";
      } catch (error) {
        console.error(error);
      }
    })();

    //
  });

  ////////////////////////////////

  var idiomaRegistros = [];

  if (idiomas) {
    for (let i = 0; i < idiomas.length; i++) {
      idiomaRegistros.push({
        key: idiomas[i].Nombre,
        text: idiomas[i].Nombre,
        value: idiomas[i].Nombre,
      });
    }
  }
  ////////////////////////////////

  // var localidadRegistros = [];

  // if (localidades) {
  //   for (let i = 0; i < localidades.length; i++) {
  //     localidadRegistros.push({
  //       key: localidades[i].Nombre,
  //       text: localidades[i].Nombre,
  //       value: localidades[i].Nombre,
  //     });
  //   }
  // }
  ////////////////////////////////

  const navigateToInicio = async () => {
    //pooling
    //setPoolingActivado(true);

    navigate(ENTORNO.URL_APLICACION + "/Pasajero/Inicio");
  };

  const [age, setAge] = React.useState("");

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div style={{ overfxlow: "hidden", touchAction: "none" }}>
      <form onSubmit={formik.handleSubmit}>
        <React.Fragment>
          <CssBaseline />
          <AppBar style={{ background: "#DC030E" }}>
            <Toolbar>
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                onClick={navigateToInicio}
                aria-label="menu"
                sx={{ mr: 2 }}
              >
                <HomeIcon />
              </IconButton>
              <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                {editar_perfil}
              </Typography>
              <IconButton
                size="large"
                aria-label="display more actions"
                edge="end"
                color="inherit"
                type="submit"
              >
                <CheckIcon />
              </IconButton>
            </Toolbar>
          </AppBar>
          <Toolbar id="back-to-top-anchor" />
          <Container>
            <Box sx={{ my: 2 }}>
              <Segment style={estiloSegmento.Pasajero}>
                <Grid
                  textalign="center"
                  container
                  style={{ padding: "1em 0em" }}
                >
                  <div className="ingresar">
                    <Grid.Row>
                      <Grid.Column style={{ maxWidth: 450 }}>
                        <Box
                          //component="form"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            "& > :not(style)": { m: 1, width: "100%" },
                          }}
                          noValidate
                          autoComplete="off"
                        >
                          {/* <Header as="h3">{general}</Header> */}
                          <br></br>
                          <TextField
                            id="nombre"
                            label={nombre}
                            placeholder={nombre}
                            variant="standard"
                            name="nombre"
                            type="text"
                            value={formik.values.nombre}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.nombre &&
                              Boolean(formik.errors.nombre)
                            }
                            helperText={
                              formik.touched.nombre && formik.errors.nombre
                            }
                            size="small"
                          />
                          <TextField
                            id="apellido"
                            label={apellido}
                            placeholder={apellido}
                            variant="standard"
                            name="apellido"
                            type="text"
                            value={formik.values.apellido}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.apellido &&
                              Boolean(formik.errors.apellido)
                            }
                            helperText={
                              formik.touched.apellido && formik.errors.apellido
                            }
                            size="small"
                          />
                          <br></br>
                          {/* <Header as="h3">{idioma}</Header> */}
                          <Box sx={{ minWidth: 120 }}>
                            <FormControl fullWidth>
                              <NativeSelect
                                value={formik.values.idioma}
                                inputProps={{
                                  name: "age",
                                  id: "uncontrolled-native",
                                }}
                                onChange={(event) => {
                                  formik.setFieldValue(
                                    "idioma",
                                    event.target.value
                                  );
                                  setIdioma(event.target.value);
                                  // window.location.reload(true);
                                }}
                                error={formik.errors.idioma}
                              >
                                {/* {idiomaRegistros.map((opcion) => (
                                  <option key={opcion.value} value={opcion.value}>
                                    &nbsp; {opcion.text}
                                  </option>
                                ))} */}

                                <option key="English" value="English">
                                  English
                                </option>
                                <option key="Español" value="Español">
                                  Español
                                </option>
                                <option key="Português" value="Português">
                                  Português
                                </option>
                              </NativeSelect>
                            </FormControl>
                          </Box>
                          {/* <Header as="h3">{localidad}</Header>
                          <Box sx={{ minWidth: 120 }}>
                            <FormControl fullWidth>
                              <NativeSelect
                                value={formik.values.localidad}
                                inputProps={{
                                  name: "age",
                                  id: "uncontrolled-native",
                                }}
                                onChange={(event) => {
                                  formik.setFieldValue(
                                    "localidad",
                                    event.target.value
                                  );
                                  setLocalidad(event.target.value);
                                  // window.location.reload(true);
                                }}
                                error={formik.errors.idioma}
                              >
                                {localidadRegistros.map((opcion) => (
                                  <option key={opcion.value} value={opcion.value}>
                                    &nbsp; {opcion.text}
                                  </option>
                                ))}
                              </NativeSelect>
                            </FormControl>
                          </Box> */}
                          <br></br>
                          {/* <Header as="h3">{contacto}</Header> */}
                          <TextField
                            id="email"
                            label={email}
                            placeholder={email}
                            disabled
                            variant="standard"
                            name="email"
                            type="text"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.email &&
                              Boolean(formik.errors.email)
                            }
                            helperText={
                              formik.touched.email && formik.errors.email
                            }
                            size="small"
                          />
                          <TextField
                            id="telefono"
                            label={telefono}
                            placeholder={telefono}
                            variant="standard"
                            name="telefono"
                            type="text"
                            value={formik.values.telefono}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.telefono &&
                              Boolean(formik.errors.telefono)
                            }
                            helperText={
                              formik.touched.telefono && formik.errors.telefono
                            }
                            size="small"
                          />
                          <TextField
                            id="identificacion"
                            label={numero_de_identificacion}
                            placeholder={numero_de_identificacion}
                            variant="standard"
                            name="identificacion"
                            type="text"
                            value={formik.values.identificacion}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.identificacion &&
                              Boolean(formik.errors.identificacion)
                            }
                            helperText={
                              formik.touched.identificacion &&
                              formik.errors.identificacion
                            }
                            size="small"
                          />

                          <div style={{ color: "gainsboro" }}>
                            <small>
                              <b>UserId</b>
                            </small>
                            <br></br>
                            <small>{getid()}</small>
                            <br></br>
                            <small>
                              <b>OS</b>
                            </small>
                            <br></br>
                            <small>{SistemaOperativo}</small>
                          </div>

                          {/* <Header as="h3">Avatar</Header>
                          <Form.Field>
                          <input
                          placeholder="Selecciona imagen"
                          type="file"
                          onChange={(e) => {
                          formik.setFieldValue(
                          "avatar",
                          URL.createObjectURL(e.target.files[0])
                          );
                          formik.setFieldValue("fileAvatar", e.target.files[0]);
                          }}
                          />
                          </Form.Field>
                          <Form.Field>
                          <Image
                          src={formik.values.avatar.replace("uploads/", "")}
                          className="Avatar"
                          centered
                          circular
                          />
                          </Form.Field> */}
                          <br></br>
                          {/* <Header as="h3">{otros}</Header> */}
                          {/* <TextField
                            id="contactosemergencia"
                            label={contactos_de_emergencia}
                            placeholder={contactos_de_emergencia}
                            variant="standard"
                            name="nombre"
                            type="text"
                            value={formik.values.contactosemergencia}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.contactosemergencia &&
                              Boolean(formik.errors.contactosemergencia)
                            }
                            helperText={
                              formik.touched.contactosemergencia &&
                              formik.errors.contactosemergencia
                            }
                            size="small"
                          /> */}
                        </Box>
                      </Grid.Column>
                    </Grid.Row>
                  </div>
                </Grid>
              </Segment>
            </Box>
          </Container>
          <ScrollTop {...props}>
            <Fab size="small" aria-label="scroll back to top">
              <KeyboardArrowUpIcon />
            </Fab>
          </ScrollTop>
        </React.Fragment>
      </form>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
        onClick={handleClose}
      >
        <Player
          src={animacion}
          className="player"
          loop
          autoplay
          style={{ height: 110 }}
        />
      </Backdrop>
    </div>
  );
}
